import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

const items = [
  {
    title: "Dashboards",
    items: [
      {
        title: "Les dashboards sont-ils configurables ?",
        content: "Non, les dashboards Edutio sont pré-configurés avec tous les indicateurs essentiels pour les CFA : taux d'assiduité, de rupture et de satisfaction. Ils sont optimisés pour être immédiatement opérationnels sans configuration complexe."
      },
      {
        title: "Quels indicateurs puis-je suivre ?",
        content: "Vous avez accès aux 3 indicateurs clés : taux d'assiduité des élèves, taux de rupture de contrat et taux de satisfaction. Ces métriques sont essentielles pour le pilotage de votre centre et vos audits Qualiopi."
      },
      {
        title: "Les données sont-elles mises à jour automatiquement ?",
        content: "Oui, tous les dashboards se mettent à jour automatiquement en temps réel avec les dernières données de votre centre. Aucune intervention manuelle n'est nécessaire."
      },
      {
        title: "Puis-je accéder aux dashboards depuis mon mobile ?",
        content: "Absolument ! L'interface est responsive et optimisée pour tous les appareils. Vous pouvez consulter vos indicateurs depuis votre smartphone ou tablette en toute sécurité."
      },
    ],
  },
  {
    title: "Extraction",
    items: [
      {
        title: "Comment extraire mes données ?",
        content: "L'extraction se fait en un clic depuis vos dashboards. Vous pouvez exporter vos données dans plusieurs formats : PDF pour les rapports, Excel pour l'analyse, CSV pour l'intégration avec d'autres outils."
      },
      {
        title: "Les données exportées sont-elles certifiées ?",
        content: "Oui, toutes les données extraites d'Edutio sont horodatées et certifiées. Elles sont parfaitement conformes aux exigences des audits Qualiopi et des organismes de financement."
      },
      {
        title: "Puis-je extraire des données sur une période spécifique ?",
        content: "Oui, vous pouvez filtrer et extraire vos données sur n'importe quelle période : par mois, trimestre, année scolaire ou dates personnalisées. L'historique complet est conservé."
      },
      {
        title: "Les rapports sont-ils prêts pour Qualiopi ?",
        content: "Absolument ! Tous les rapports générés sont conformes aux exigences Qualiopi. Ils incluent automatiquement toutes les informations requises : assiduité, satisfaction, suivi des objectifs pédagogiques."
      },
    ],
  },
  {
    title: "Audits Qualiopi",
    items: [
      {
        title: "Comment Edutio simplifie-t-il mes audits Qualiopi ?",
        content: "Edutio génère automatiquement tous les rapports nécessaires pour vos audits : preuves d'assiduité, enquêtes de satisfaction, suivi des objectifs pédagogiques et identification des élèves à risque. Tout est prêt en quelques clics."
      },
      {
        title: "Les données sont-elles conformes aux exigences réglementaires ?",
        content: "Oui, toutes les données collectées et les rapports générés respectent scrupuleusement les exigences Qualiopi et des organismes de financement. Les preuves de conformité sont automatiquement conservées."
      },
      {
        title: "Comment identifier les élèves à risque de décrochage ?",
        content: "Edutio analyse automatiquement les taux d'assiduité et de satisfaction pour identifier les apprenants en difficulté. Vous recevez des alertes pour intervenir rapidement et prévenir les ruptures de contrat."
      },
    ],
  },
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            Questions fréquentes
          </div>
          <h2 className={cn("h2", styles.title)}>FAQ – Questions fréquentes</h2>
          <div className={styles.info}>
            Découvrez les réponses aux questions les plus courantes sur nos dashboards et l'extraction de données ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
